import {mapState} from 'vuex'

export default {
    computed: {
        sortedMenuItems() {
            let sortedMenuItems = [];

            if (this.apps.length) {
                let apps = [...this.apps];
                apps
                    .sort(function (a, b) {
                        return (a.order > b.order) ? 1 : -1;
                    })
                    .map(app => {
                        return {...app, sub: apps.filter(item => item.parent_id === app.id)};
                    })
                    .filter(app => !app.parent_id)
                    .forEach(app => {
                        if (this.$root.menuItems.find(item => item.label === app.name) !== undefined) {
                            let new_app = this.$root.menuItems.find(item => (item.label === app.name));
                            if ((app.sub).length > 0) {
                                let subItems = new_app.subItems;
                                new_app.subItems = new_app.subItems.filter(subItem => subItem && subItem.label === 'Overview');
                                app.sub.forEach(sub => {
                                    new_app.subItems.push(subItems.find(subItem => subItem && subItem.label === sub.name));
                                });
                            }
                            sortedMenuItems.push(new_app)
                        }
                        sortedMenuItems = sortedMenuItems.filter(item => item.display);
                    });
            }
            
            return sortedMenuItems;
        },

        ...mapState([
            'apps',
        ]),
    },
}
